/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect } from 'react';
import { withRouter } from 'react-router';
import mbpUtil from 'mbp-api-util';
import { Grid } from '@material-ui/core';
import { bool, object } from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { loadYotpoSkeleton, loadYotpoImages, addLibraries } from '../../../../../helpers/commonFunctions';

const styles = (theme) => ({
    reviewPageMainWrapper: {
        '& .yotpo .yotpo-pager .yotpo-page-element.yotpo-active': {
            color: '#000 !important',
            padding: '3px 8px',
            borderRadius: '50%',
            backgroundColor: `${theme.palette.primary.main} !important`,
        },
    },
});

const YotpoHPWidget = ({ isCustomerReviewPage, classes }) => {
    const APP_YOTPO_CLIENT_ID = mbpUtil.getEnv('APP_YOTPO_CLIENT_ID');
    const APP_YOTPO_GALLERY_ID = mbpUtil.getEnv('APP_YOTPO_GALLERY_ID');
    const yotpoClientURL = `https://staticw2.yotpo.com/${APP_YOTPO_CLIENT_ID}/widget.js`;

    useEffect(() => {
        addLibraries(yotpoClientURL, '', false, true);
        setTimeout(() => {
            if (typeof document !== 'undefined') {
                const yotpoPictureWidget = document.querySelector('.yotpo-pictures-widget');
                if (yotpoPictureWidget || document.querySelector('#yotpo-testimonials-custom-tab')) {
                    loadYotpoImages();
                    loadYotpoSkeleton();
                    if (yotpoPictureWidget) {
                        setTimeout(() => {
                            yotpoPictureWidget.classList.remove('initial-skeleton');
                        }, 1500);
                    }
                }
            }
        }, 0);
    }, []);

    return (
        isCustomerReviewPage ? (
            <>
                <Grid className={`p-3 customer-reviews ${classes.reviewPageMainWrapper}`}>
                    <div id="yotpo-testimonials-custom-tab" />
                </Grid>
            </>
        )
            : (
                <>
                    <div className="yotpo yotpo-pictures-widget initial-skeleton" data-gallery-id={APP_YOTPO_GALLERY_ID} style={{ visibility: ((typeof document !== 'undefined') ? window?.yotpo?.cssReady : false) ? 'visible' : 'hidden' }} />
                </>
            )
    );
};

YotpoHPWidget.propTypes = {
    isCustomerReviewPage: bool,
    classes: object.isRequired,
};

YotpoHPWidget.defaultProps = {
    isCustomerReviewPage: false,
};

export default withRouter(withStyles(styles)(YotpoHPWidget));
